<template>
  <div>
    <MasterAssignedGroupClassList
      @refetch="updateMasterCreatedGroupClasses"
    ></MasterAssignedGroupClassList>
    <MasterCreatedGroup
      ref="materCreatedGroupClasses"
      @refetch="updateFinishedGroupClasses"
    ></MasterCreatedGroup>
    <MasterFinishedGroupClassList
      ref="masterFinishedGroupClasses"
    ></MasterFinishedGroupClassList>
  </div>
</template>

<script>
export default {
  methods: {
    updateFinishedGroupClasses() {
      if (
        this.$refs.masterFinishedGroupClasses &&
        this.$refs.masterFinishedGroupClasses.getMasterFinishedGroupClassesList
      ) {
        this.$refs.masterFinishedGroupClasses.getMasterFinishedGroupClassesList();
      }
    },
    updateMasterCreatedGroupClasses() {
      if (
        this.$refs.materCreatedGroupClasses &&
        this.$refs.materCreatedGroupClasses.getAllMasterCreatedClasses
      ) {
        this.$refs.materCreatedGroupClasses.getAllMasterCreatedClasses();
      }
    },
  },
  components: {
    MasterAssignedGroupClassList,
    MasterCreatedGroup,
    MasterFinishedGroupClassList,
  },
};
import MasterAssignedGroupClassList from "@/views/components/GroupClass/MasterGroupClass/MasterAssignedGroupClassList.vue";
import MasterCreatedGroup from "@/views/components/GroupClass/MasterGroupClass/MasterCreatedGroup.vue";
import MasterFinishedGroupClassList from "@/views/components/GroupClass/MasterGroupClass/MasterFinishedGroupClassList.vue";
</script>
